module.exports = __webpack_public_path__ + "img/sms_icon.9f0512d7.svg";